export default __webpack_public_path__ + "static/coin-telegraph-486a229ea08ece0000a5dfc20b9809ec.png";